 
import { API } from "../Axios/Axios";
import { userLogout } from "../Helpers/APIEndpoints/Endpoints";
import { NavigateFunction } from "react-router-dom";

export const logoutUser = async (
  username?: string,
  navigate?: NavigateFunction
) => {
  const getUserContext = () => ({
    userAgent: navigator.userAgent,
    language: navigator.language,
    platform: navigator.platform,// NOSONAR : ignore
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });

  try {
    const userContext = getUserContext();
    if (username) {
      await API.post(userLogout, {
        loginId: username,
        ipAddress: "",
        ...userContext,
      });
    }
  } catch (error) {
    console.error("Logout API failed:", error);
  }

  // Clear localStorage and sessionStorage
  localStorage.clear();
  sessionStorage.clear();

  // Clear all cookies
  document.cookie.split(";").forEach((cookie) => {
    document.cookie = cookie
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
  });

  // Clear caches if supported
  if ("caches" in window) {
    caches.keys().then((names) => {
      names.forEach((name) => caches.delete(name));
    });
  }

   

  if (navigate) {
    navigate("/login");
  } else {
    window.location.href = "/login";
  }
};
